var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "384",
        height: "210",
        viewBox: "0 0 384 210",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M311.424 45.3188H183.734V209.154H311.424V45.3188Z",
          fill: "#D0D0D0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M359.01 0.933594H231.321V45.7657H359.01V0.933594Z",
          fill: "#D0D0D0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M267.162 209.154V46.5985H278.864V1.21143",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M243.525 119.622L265.54 103.595H183.822L161.807 119.622H243.525Z",
          fill: "#E6E6E6"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M333.399 32.6399L311.385 16.6123H362.646L384.661 32.6399H333.399Z",
          fill: "#E6E6E6"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M349.95 128.935L349.95 209.154L252.607 209.154L252.607 128.935L349.95 128.935Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M349.95 128.935V124.322L346.794 119.709H318.819L313.638 128.935H349.95Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M346.918 137.669L346.918 208.434L258.545 208.434L258.545 137.669L346.918 137.669Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M367.168 148.227L349.95 209.154H252.607L272.063 140.309H333.094L336.037 148.227H367.168Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M199.258 60.3677H311.413",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M231.291 8.65527H343.446",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M255.568 23.2262L312.976 23.2261",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M183.806 89.5156H294.57",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M182.414 154.948H252.662",
          stroke: "#8E8E8E",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M96.6288 139.496L132.226 103.595L194.49 112.021L208.288 156.471L201.894 160.134L208.288 199.87L219.449 201.776L224.834 209.102H72.3968V204.341L81.5554 201.776L89.7295 183.093L85.8591 176.131L100.331 160.867L96.6288 139.496Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M186.453 141.612L192.978 136.83L195.966 160.883L186.537 156.218L186.453 141.612Z",
          fill: "#178268"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M188.575 168.689L193.42 167.742L193.461 174.878L186.708 174.69L188.575 168.689Z",
          fill: "#178268"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M148.793 205.072L174.708 198.477L188.73 202.098",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M113.123 180.892V186.022H118.508L123.22 180.892L130.624 177.961",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M173.574 117.271V132.29L180.705 134.336L182.388 124.444",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M142.378 153.224H112.786V146.676H142.378V153.224Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M142.377 153.224H119.645V146.678H142.377V153.224Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M159.39 70.2075L171.902 91.9627L160.988 117.945L147.838 112.423L155.646 93.8335L145.952 77.2073L159.39 70.2075Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M123.282 59.861L126.764 46.8696L142.716 37.6597L155.707 41.1407L164.917 57.0929L161.436 70.0843L145.484 79.2943L132.492 75.8133L123.282 59.861Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M121.841 62.7186L124.66 52.2017L137.573 44.7461L148.09 47.5641L155.546 60.4777L152.727 70.9946L139.814 78.4502L129.297 75.6323L121.841 62.7186Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M118.017 63.2209L121.6 49.8508L137.072 40.918L150.442 44.5005L159.375 59.9725L155.792 73.3426L140.32 82.2754L126.95 78.6929L118.017 63.2209ZM124.662 52.2003L121.844 62.7171L129.3 75.6308L139.817 78.4488L152.73 70.993L155.548 60.4762L148.092 47.5625L137.575 44.7446L124.662 52.2003Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M137.106 67.5522L132.474 70.2266L135.148 74.8587L139.78 72.1843L137.106 67.5522Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M155.611 183.186H125.316V201.941H155.611V183.186Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M19.4561 209.102L47.4508 156.879H144.794L116.799 209.102H19.4561Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M2.23749 148.176L19.4557 209.102H116.799L97.3425 140.257H48.6193L45.6765 148.176H2.23749Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.4041 159.066H0V183.605H18.4041V159.066Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M100.923 157.461L115.077 203",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M28.9114 176.211L27.5579 171.044H25.5856L25.2677 169.832H30.7095L31.0273 171.044H29.055L30.4084 176.211H28.9114ZM33.3377 176.211L31.6665 169.832H33.1534L33.7993 172.297H35.5998L34.9539 169.832H36.4406L38.112 176.211H36.6251L35.9279 173.55H34.1274L34.8246 176.211H33.3377ZM39.6859 176.211L38.0147 169.832H42.3843L42.7022 171.044H39.8295L40.1653 172.327H42.603L42.9183 173.53H40.4806L40.8651 174.998H43.8388L44.1567 176.211H39.6859ZM47.8855 176.328C47.3595 176.328 46.8644 176.201 46.3999 175.946C45.9353 175.693 45.5278 175.321 45.177 174.831C44.8246 174.335 44.5527 173.722 44.3614 172.993C44.175 172.281 44.13 171.684 44.2261 171.202C44.3204 170.712 44.534 170.344 44.867 170.095C45.1982 169.842 45.6267 169.714 46.1527 169.714C46.6787 169.714 47.1739 169.842 47.6384 170.095C48.1012 170.344 48.5079 170.712 48.8587 171.202C49.2076 171.684 49.4752 172.281 49.6615 172.993C49.8529 173.722 49.9023 174.335 49.8096 174.831C49.7153 175.321 49.5025 175.693 49.1713 175.946C48.8401 176.201 48.4115 176.328 47.8855 176.328ZM47.56 175.086C47.7893 175.086 47.9676 175.007 48.0953 174.851C48.2211 174.689 48.2878 174.454 48.295 174.147C48.3075 173.833 48.2538 173.449 48.1342 172.993C48.018 172.548 47.8734 172.177 47.7003 171.876C47.534 171.576 47.3461 171.348 47.1366 171.192C46.927 171.036 46.7076 170.957 46.4783 170.957C46.249 170.957 46.0705 171.036 45.943 171.192C45.8154 171.348 45.7438 171.576 45.728 171.876C45.7189 172.177 45.7724 172.548 45.8887 172.993C46.0083 173.449 46.153 173.833 46.3227 174.147C46.4974 174.454 46.6903 174.689 46.9017 174.851C47.1113 175.007 47.3307 175.086 47.56 175.086ZM51.5934 176.211L49.922 169.832H52.2586C52.7238 169.832 53.1649 169.894 53.5818 170.018C53.9968 170.135 54.3575 170.34 54.6636 170.634C54.9749 170.921 55.1963 171.315 55.3279 171.818C55.456 172.307 55.4422 172.705 55.2865 173.011C55.1376 173.319 54.8906 173.546 54.5455 173.697C54.1988 173.841 53.7927 173.912 53.3275 173.912H52.4778L53.0801 176.211H51.5934ZM52.1779 172.767H52.9062C53.2972 172.767 53.5734 172.689 53.7348 172.532C53.9011 172.369 53.9433 172.131 53.8612 171.818C53.7792 171.505 53.6174 171.287 53.3759 171.162C53.1412 171.038 52.8282 170.977 52.4371 170.977H51.7088L52.1779 172.767ZM52.9569 173.54L53.7451 172.61L56.7924 176.211H55.1233L52.9569 173.54ZM59.2362 176.211L58.6723 174.058L55.4407 169.832H57.0389L58.1089 171.368C58.2734 171.609 58.4343 171.85 58.592 172.092C58.7546 172.327 58.9199 172.572 59.0876 172.825H59.1281C59.1694 172.572 59.2099 172.327 59.2495 172.092C59.294 171.85 59.3321 171.609 59.3632 171.368L59.6283 169.832H61.186L60.1692 174.058L60.7332 176.211H59.2362ZM72.1454 176.328C71.6193 176.328 71.1242 176.201 70.6597 175.946C70.1952 175.693 69.7876 175.321 69.4369 174.831C69.0844 174.335 68.8126 173.722 68.6212 172.993C68.435 172.281 68.3898 171.684 68.4859 171.202C68.5802 170.712 68.7939 170.344 69.1268 170.095C69.458 169.842 69.8865 169.714 70.4126 169.714C70.9386 169.714 71.4337 169.842 71.8982 170.095C72.361 170.344 72.7678 170.712 73.1185 171.202C73.4675 171.684 73.7351 172.281 73.9214 172.993C74.1127 173.722 74.1621 174.335 74.0694 174.831C73.9751 175.321 73.7623 175.693 73.4311 175.946C73.0999 176.201 72.6713 176.328 72.1454 176.328ZM71.8198 175.086C72.0491 175.086 72.2275 175.007 72.3551 174.851C72.4809 174.689 72.5476 174.454 72.5548 174.147C72.5673 173.833 72.5136 173.449 72.394 172.993C72.2778 172.548 72.1332 172.177 71.9601 171.876C71.794 171.576 71.606 171.348 71.3964 171.192C71.1868 171.036 70.9674 170.957 70.7381 170.957C70.5088 170.957 70.3305 171.036 70.2028 171.192C70.0753 171.348 70.0036 171.576 69.9878 171.876C69.9787 172.177 70.0324 172.548 70.1486 172.993C70.2682 173.449 70.4128 173.833 70.5825 174.147C70.7572 174.454 70.9502 174.689 71.1615 174.851C71.3711 175.007 71.5905 175.086 71.8198 175.086ZM76.2071 176.211L74.5359 169.832H78.9156L79.2335 171.044H76.3406L76.7276 172.522H79.1957L79.5135 173.736H77.0455L77.694 176.211H76.2071ZM30.6751 188.118L29.0037 181.737H33.3734L33.6912 182.951H30.8186L31.1543 184.232H33.5921L33.9073 185.436H31.4697L31.8542 186.904H34.8279L35.1457 188.118H30.6751ZM37.9537 188.118L34.2899 181.737H35.8678L37.4359 184.712C37.6294 185.064 37.8068 185.406 37.9681 185.74C38.1345 186.066 38.311 186.404 38.4977 186.758H38.5381C38.5537 186.404 38.5559 186.066 38.5446 185.74C38.5385 185.406 38.5364 185.064 38.5385 184.712L38.5381 181.737H40.0553L39.7441 188.118H37.9537ZM42.8049 188.118L41.1337 181.737H45.5033L45.8212 182.951H42.9486L43.2843 184.232H45.722L46.0373 185.436H43.5996L43.9841 186.904H46.9579L47.2757 188.118H42.8049ZM48.6474 188.118L46.9761 181.737H49.3126C49.7779 181.737 50.219 181.8 50.6358 181.923C51.051 182.041 51.4116 182.247 51.7178 182.54C52.0289 182.826 52.2503 183.222 52.3819 183.724C52.51 184.214 52.4964 184.611 52.3406 184.918C52.1916 185.224 51.9446 185.453 51.5996 185.602C51.2528 185.746 50.8468 185.817 50.3815 185.817H49.5318L50.1343 188.118H48.6474ZM49.232 184.673H49.9603C50.3514 184.673 50.6276 184.595 50.7888 184.438C50.9551 184.275 50.9973 184.036 50.9152 183.724C50.8332 183.411 50.6715 183.192 50.4299 183.068C50.1952 182.945 49.8822 182.882 49.4912 182.882H48.7628L49.232 184.673ZM50.011 185.446L50.7993 184.516L53.8464 188.118H52.1775L50.011 185.446ZM56.2902 188.118L55.7263 185.965L52.4949 181.737H54.0931L55.163 183.273C55.3274 183.514 55.4884 183.757 55.646 183.998C55.8087 184.232 55.9739 184.477 56.1417 184.732H56.1822C56.2234 184.477 56.2639 184.232 56.3035 183.998C56.3482 183.757 56.3861 183.514 56.4172 183.273L56.6823 181.737H58.2401L57.2233 185.965L57.7872 188.118H56.2902ZM62.3552 188.118L61.0017 182.951H59.0294L58.7115 181.737H64.1534L64.4711 182.951H62.4987L63.8522 188.118H62.3552ZM66.7815 188.118L65.1103 181.737H66.5972L67.2431 184.204H69.0436L68.3975 181.737H69.8844L71.5557 188.118H70.0689L69.3717 185.455H67.5712L68.2684 188.118H66.7815ZM72.9477 188.118L72.6298 186.904H74.1673L73.1317 182.951H71.5942L71.2764 181.737H75.8483L76.1662 182.951H74.6287L75.6643 186.904H77.2017L77.5195 188.118H72.9477ZM78.9317 188.118L77.2604 181.737H78.7877L81.0039 184.908L81.9396 186.317H81.9801C81.8575 185.977 81.7145 185.599 81.5512 185.182C81.3878 184.764 81.2575 184.37 81.1601 183.998L80.568 181.737H81.9942L83.6655 188.118H82.1381L79.9193 184.937L78.9889 183.548H78.9484C79.0728 183.894 79.2156 184.271 79.3772 184.682C79.5371 185.087 79.6666 185.479 79.7658 185.857L80.3579 188.118H78.9317ZM87.8292 188.234C87.2695 188.234 86.7287 188.114 86.207 187.873C85.6836 187.624 85.2238 187.26 84.8276 186.776C84.4297 186.287 84.1367 185.684 83.9487 184.967C83.7625 184.255 83.7392 183.652 83.8792 183.156C84.0172 182.654 84.2815 182.273 84.6716 182.012C85.0686 181.751 85.5503 181.62 86.1167 181.62C86.5617 181.62 86.9649 181.705 87.3263 181.875C87.6859 182.038 87.9977 182.223 88.2613 182.433L87.6753 183.322C87.4979 183.186 87.3136 183.075 87.1228 182.99C86.9321 182.905 86.7052 182.862 86.4422 182.862C86.159 182.862 85.9249 182.947 85.7401 183.117C85.5536 183.281 85.433 183.514 85.3785 183.822C85.3307 184.129 85.3623 184.493 85.4734 184.918C85.5878 185.354 85.7434 185.73 85.9401 186.042C86.135 186.349 86.372 186.584 86.6506 186.748C86.9294 186.91 87.2407 186.991 87.5846 186.991C87.7127 186.991 87.8298 186.975 87.9359 186.943C88.0487 186.91 88.1303 186.861 88.1807 186.796L87.8935 185.7H86.9327L86.6251 184.526H88.9211L89.6901 187.462C89.5206 187.663 89.2709 187.843 88.9411 187.999C88.6179 188.156 88.2473 188.234 87.8292 188.234Z",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }